// extracted by mini-css-extract-plugin
module.exports = {"contentParagraph":"ContentPage_contentParagraph__ULT22","contentImageRes":"ContentPage_contentImageRes__M3kc7"};